export default __webpack_public_path__ + "static/media/undraw_adventure_4hum.2b64fca5.svg";